import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "default-table-area campaigns-table customer-ratings-table px-20" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table border-0" }
const _hoisted_6 = {
  class: "fs-14 text-secondary border-border-color-50",
  style: {"padding-top":"17px","padding-bottom":"17px"}
}
const _hoisted_7 = {
  class: "border-border-color-50",
  style: {"padding-top":"17px","padding-bottom":"17px"}
}
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = { class: "flex-shrink-0" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "flex-grow-1 ms-2" }
const _hoisted_12 = { class: "fs-14 fw-semibold mb-0 text-secondary-50" }
const _hoisted_13 = {
  class: "border-border-color-50",
  style: {"padding-top":"17px","padding-bottom":"17px"}
}
const _hoisted_14 = { class: "d-flex align-items-center gap-1" }
const _hoisted_15 = { class: "fs-12 text-body position-relative top-1" }
const _hoisted_16 = {
  class: "border-border-color-50",
  style: {"padding-top":"17px","padding-bottom":"17px"}
}
const _hoisted_17 = { class: "fs-14 fw-semibold text-secondary mb-1" }
const _hoisted_18 = {
  class: "fs-14 text-body",
  style: {"max-width":"617px","line-height":"1.8"}
}
const _hoisted_19 = {
  class: "fs-14 text-secondary border-border-color-50",
  style: {"padding-top":"17px","padding-bottom":"17px"}
}
const _hoisted_20 = {
  class: "text-end border-border-color-50",
  style: {"padding-top":"17px","padding-bottom":"17px"}
}
const _hoisted_21 = { class: "d-flex justify-content-end align-items-center gap-2" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap" }
const _hoisted_24 = { class: "fs-13" }
const _hoisted_25 = { "aria-label": "Page navigation example" }
const _hoisted_26 = { class: "pagination mb-0 justify-content-center" }
const _hoisted_27 = { class: "page-item" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "page-item" }
const _hoisted_31 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[9] || (_cache[9] = _createElementVNode("h5", { class: "mb-4" }, "Reviews", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
              _createElementVNode("tr", { class: "border-bottom" }, [
                _createElementVNode("th", { scope: "col" }, [
                  _createElementVNode("span", { class: "fs-14 text-secondary fw-medium letter-spacing-1" }, " User ID ")
                ]),
                _createElementVNode("th", { scope: "col" }, [
                  _createElementVNode("span", { class: "fs-14 text-secondary fw-medium letter-spacing-1" }, " Customer Name ")
                ]),
                _createElementVNode("th", { scope: "col" }, [
                  _createElementVNode("span", { class: "fs-14 text-secondary fw-medium letter-spacing-1" }, " Ratings ")
                ]),
                _createElementVNode("th", { scope: "col" }, [
                  _createElementVNode("span", { class: "fs-14 text-secondary fw-medium letter-spacing-1" }, " Reviews ")
                ]),
                _createElementVNode("th", { scope: "col" }, [
                  _createElementVNode("span", { class: "fs-14 text-secondary fw-medium letter-spacing-1" }, " Date ")
                ]),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-end"
                }, [
                  _createElementVNode("span", { class: "fs-10 text-secondary fw-medium letter-spacing-1" })
                ])
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedReviews, (review) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: review.id
                }, [
                  _createElementVNode("td", _hoisted_6, " #" + _toDisplayString(review.id.toString().padStart(3, "0")), 1),
                  _createElementVNode("td", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("img", {
                          src: review.avatar,
                          class: "rounded-circle",
                          style: {"width":"30px","height":"30px"},
                          alt: "user"
                        }, null, 8, _hoisted_10)
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("h4", _hoisted_12, _toDisplayString(review.name), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _cache[2] || (_cache[2] = _createElementVNode("i", { class: "text-danger ri-star-fill" }, null, -1)),
                      _createElementVNode("span", _hoisted_15, _toDisplayString(review.rating), 1)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_16, [
                    _createElementVNode("h4", _hoisted_17, _toDisplayString(review.title), 1),
                    _createElementVNode("p", _hoisted_18, _toDisplayString(review.content), 1)
                  ]),
                  _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.formatDate(review.date)), 1),
                  _createElementVNode("td", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _cache[4] || (_cache[4] = _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                        _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, " visibility ")
                      ], -1)),
                      _cache[5] || (_cache[5] = _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                        _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary-div-50" }, " edit ")
                      ], -1)),
                      _createElementVNode("button", {
                        class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2",
                        onClick: ($event: any) => (_ctx.deleteReview(review.id))
                      }, [...(_cache[3] || (_cache[3] = [
                        _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, " delete ", -1)
                      ]))], 8, _hoisted_22)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("span", _hoisted_24, " Showing " + _toDisplayString(_ctx.showingStart) + " to " + _toDisplayString(_ctx.showingEnd) + " of " + _toDisplayString(_ctx.totalReviews) + " Results ", 1),
          _createElementVNode("nav", _hoisted_25, [
            _createElementVNode("ul", _hoisted_26, [
              _createElementVNode("li", _hoisted_27, [
                _createElementVNode("button", {
                  class: "page-link icon hover-bg",
                  "aria-label": "Previous",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args))),
                  disabled: _ctx.currentPage === 1
                }, [...(_cache[7] || (_cache[7] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_left", -1)
                ]))], 8, _hoisted_28)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "page-item",
                  key: page
                }, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["page-link", { active: _ctx.currentPage === page }]),
                    onClick: ($event: any) => (_ctx.goToPage(page))
                  }, _toDisplayString(page), 11, _hoisted_29)
                ]))
              }), 128)),
              _createElementVNode("li", _hoisted_30, [
                _createElementVNode("button", {
                  class: "page-link icon hover-bg",
                  "aria-label": "Next",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
                  disabled: _ctx.currentPage === _ctx.totalPages
                }, [...(_cache[8] || (_cache[8] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_right", -1)
                ]))], 8, _hoisted_31)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}